import {PageLink} from '../../_metronic/layout/core'

export const BreadcrumbsConst = (title: string, path: string): Array<PageLink> => {
  return [
    {
      title: title,
      path: path,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
}